<template>
  <o-scroll>
    <div class="p-4 sm:p-10">
      <div class="grid gap-8 sm:grid-cols-[minmax(0,2fr)_minmax(12rem,1fr)] sm:gap-12">
        <div>
          <p class="text-sm uppercase opacity-75 mb-5 font-medium">
            {{ integration.name }}
          </p>
          <p class="text-sm opacity-75 leading-normal">
            {{ integration.description }}
          </p>
        </div>
        <div>
          <p class="text-sm uppercase opacity-75 mb-5 font-medium">
            {{ $t('components.integration.edit.overview.platforms') }}
          </p>
          <ul class="text-sm opacity-75 leading-none">
            <li v-if="isPlatformWeb" class="mb-3 flex items-center space-x-3">
              <o-icon icon="web" class="opacity-75 inline-block" :size="18" />
              <span>{{ $t('components.integration.edit.overview.webDesktop') }}</span>
            </li>
            <li v-if="isPlatformApple" class="mb-3 flex items-center space-x-3">
              <o-icon icon="apple" class="opacity-75 inline-block" :size="18" />
              <span>{{ $t('components.integration.edit.overview.apple') }}</span>
            </li>
            <li v-if="isPlatformAndroid" class="mb-3 flex items-center space-x-3">
              <o-icon icon="android" class="opacity-75 inline-block" :size="18" />
              <span>{{ $t('components.integration.edit.overview.android') }}</span>
            </li>
          </ul>
        </div>
      </div>

      <!--<div class="mt-24">
        <p class="text-sm uppercase opacity-75 mb-5 font-medium">
          Features
        </p>
        <ul class="text-sm text-gray-700 dark:text-gray-200">
          <li class="mb-3 flex items-center space-x-3">
            <o-icon icon="check" class="text-white inline-block p-2 rounded-full bg-green-400" fill :size="12" />
            <span>Hard cheese monterey jack stinking bishop.</span>
          </li>
          <li class="mb-3 flex items-center space-x-3">
            <o-icon icon="check" class="text-white inline-block p-2 rounded-full bg-green-400" fill :size="12" />
            <span>Lancashire cheese slices camembert de normandie queso fromage frais squirty cheese halloumi croque monsieur.</span>
          </li>
          <li class="mb-3 flex items-center space-x-3">
            <o-icon icon="check" class="text-white inline-block p-2 rounded-full bg-green-400" fill :size="12" />
            <span>St. agur blue cheese stinking bishop taleggio when the cheese comes out everybody's happy danish fontina camembert.</span>
          </li>
          <li class="mb-3 flex items-center space-x-3">
            <o-icon icon="check" class="text-white inline-block p-2 rounded-full bg-green-400" fill :size="12" />
            <span>Queso lancashire dolcelatte. Cow cut the cheese everyone loves cheese slices pepper jack gouda</span>
          </li>
        </ul>
      </div>-->

      <!--<div class="mt-24">
        <p class="text-sm uppercase opacity-75 mb-5 font-medium">
          Screenshots
        </p>
        <div class="flex items-start space-x-3">
          <div class="w-40 h-24 bg-gray-300 rounded-md" />
          <div class="w-40 h-24 bg-gray-300 rounded-md" />
          <div class="w-20 h-24 bg-gray-300 rounded-md" />
          <div class="w-20 h-24 bg-gray-300 rounded-md" />
        </div>
      </div>-->
    </div>
  </o-scroll>
</template>

<script setup lang="ts">
interface Props {
  integration: Record<string, any>
}

const props = defineProps<Props>()

const isPlatformWeb = computed(() => {
  return props.integration.isPlatformWeb
})

const isPlatformApple = computed(() => {
  return props.integration.isPlatformApple
})

const isPlatformAndroid = computed(() => {
  return props.integration.isPlatformAndroid
})
</script>
